export { FullCalendar as FullCalendarLocale } from "./FullCalendar";
export { Vuetify as VuetifyLocale } from "./Vuetify";
import "./Moment";

export const Locale = "sv-SE";
export const Country = "SE";
export const Currency = "SEK";
